import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const LeadApi = createApi({
  reducerPath: "LeadApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["LEAD"],
  endpoints: (build) => ({
    getLeads: build.query({
      query: (params) => ({
        url: "/leads",
        params,
      }),
      providesTags: ["LEAD"],
    }),
    exportLeads: build.mutation({
      query: (params) => ({
        url: "/leads/export",
        method: "GET",
        params,
        responseHandler: (response) => response.blob(),
      }),
    }),
    createLead: build.mutation({
      query: (body) => ({
        url: "/leads",
        method: "POST",
        body,
      }),
      invalidatesTags: ["LEAD"],
    }),
  }),
});

export const { useGetLeadsQuery, useExportLeadsMutation, useCreateLeadMutation } = LeadApi;